<template>
  <div class="footer-box show-flex-box-r show-flex-center">
    <dl v-show="showType =='cn'" class="show-flex-box-c show-flex-center">
      <dt><strong>Copyright © zgsfxg.cn Rights Reserved 中国书法出版传媒有限责任公司 版权所有</strong>
      </dt>
      <dd class="show-flex-box-r">
        <a href="/web/home/image/propagate_licence" target="_blank">信息网络传播视听节目许可证</a>
        <a href="/web/home/image/program_licence" target="_blank">广播电视节目制作经营许可证</a>
        <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17021681号-2</a>
      </dd>
    </dl>
    <dl v-show="showType =='com'" class="show-flex-box-c show-flex-center">
      <dt><strong>Copyright © zgsfxg.com Rights Reserved 中国书法出版传媒有限责任公司 版权所有</strong>
      </dt>
      <dd class="show-flex-box-r">
        <a href="/web/home/image/propagate_licence" target="_blank">信息网络传播视听节目许可证</a>
        <a href="/web/home/image/program_licence" target="_blank">广播电视节目制作经营许可证</a>
        <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17021681号-3</a>
      </dd>
    </dl>
  </div>
</template>

<script>

  export default {
    name: "home",
    data() {
      return {
        showType: '',
        domainName: '',
        companyName: '',
        recordNo: '',
      };
    },
    components: {},
    computed: {
      listenStartupData: function() {
        return this.$store.state.startup;
      },
    },
    mounted() {
      this.setShowTypeByDomain();
    },
    methods: {
      setShowTypeByDomain: function() {
        const domain = window.location.host;
        const formatType = {
          '.com': 'com',
          '.cn': 'cn'
        };
        let showType = '';

        for(let key in formatType) {
          if (formatType.hasOwnProperty(key) && domain.indexOf(key) != -1) {
            showType = formatType[key];
          }
        }

        this.showType = showType || 'com';
      },
      setFooterShowInfoByStartUp: function() {
        // 由于未监测到备案跳转，故放弃线上调用，改为本地
        var startupInfo = this.listenStartupData;
     
        if (!startupInfo) {
          return;
        }

        var siteInfo = startupInfo.site_info || {};

        this.domainName = siteInfo.domain;
        this.companyName = siteInfo.company;
        this.recordNo = siteInfo.record_n_varchar;
      },
      openBeiAnWeb: function() {
        window.open('https://beian.miit.gov.cn/','_blank');
      },
    },
    watch: {
      listenStartupData: function() {
        this.setFooterShowInfoByStartUp();
      },
    }
  };

</script>
<style lang="less" scoped>
  .footer-box {
    height: 100%;
    &>dl {
      &>dt {
        margin-bottom: 10px;
        &>strong {
          display: block;
          font-size: 12px;
          font-family: PingFangSC-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #837E7E;
        }
      }
      &>dd {
        &>a {
          display: block;
          font-size: 12px;
          font-family: PingFangSC-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #837E7E;
          margin-right: 15px;
          &:last-child {
            margin-right: 0;
          }
          &:hover{
            text-decoration: underline;
            cursor: pointer;
          }
        }
        &>em {
          display:block;
          width: 1px;
          height: 10px;
          margin-left: 20px;
          margin-right: 20px;
          background: #C1BEBE;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/publick/footer_cpn.vue